var render = function render(_c,_vm){return _c('a',{staticClass:"button button-navy button-lg px-10 rounded-xl",attrs:{"href":"https://safewill-au.typeform.com/to/KbvVEnsC","target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.$t('common.links.getInTouch'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }